module.exports = __webpack_public_path__ + "img/keder_ultramarinblau_ral5002.b7aa18ea.jpg";